module.exports = __webpack_public_path__ + "img/bg_challenge.0664800e.jpg";